import black from '@lifeomic/chroma-react/colors/black';
import charcoal from '@lifeomic/chroma-react/colors/charcoal';
import grey from '@lifeomic/chroma-react/colors/grey';
import { PaletteOptions } from '@lifeomic/chroma-react/styles';
import { alpha } from '@mui/material/styles';
import { ColorMode } from '../../redux/modules/colorMode/reducer';

/** App chrome sidebar — slightly elevated from main canvas in dark mode. */
export const DARK_SIDEBAR_BACKGROUND = black[800];

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  background: {
    default: black[900],
    paper: charcoal[900],
  },
  text: {
    primary: grey[100],
    secondary: grey[300],
    hint: grey[400],
    disabled: grey[500],
  },
  divider: alpha(grey[100], 0.12),
  action: {
    hover: alpha(grey[100], 0.08),
    selected: alpha(grey[100], 0.14),
  },
};

export const getPaletteForColorMode = (
  mode: ColorMode,
): PaletteOptions | undefined => (mode === 'dark' ? darkPalette : undefined);
